// 9fbef606107a605d69c0edbcd8029e5d
/**
 * @method getPromotionalMessage - this function checks whether the user is PLCC or not and
 *         returns the message respectively
 * @param isPlcc  boolean value for plcc user
 * @param {handlers}  the messages containing both plcc user message and non-plcc user message
 */

/* eslint-disable */
const getPromotionalMessage = (isPlcc, handlers) => {
  if (!!handlers.promotionalPLCCMessage || !!handlers.promotionalMessage) {
    return isPlcc ? handlers.promotionalPLCCMessage : handlers.promotionalMessage;
  }
};

/**
 * @method getAddToBagFormName - this method returns the form name with productId appending the
 * text 'AddToBagForm-'
 * @param {string} productId - id needs to be append to the add to bag text
 */
// const getAddToBagFormName = productId => labels.ADD_TO_BAG_FORM_NAME + productId;

/**
 * @method validateBossEligibility
 * @description checks the bopis product flags for returning the boolean
 * value
 * @param {bool} isBossClearanceProductEnabled this flag is derived through the kill
 * Switch API. If a product is of Clearance then we need to check this kill switch
 * @param {bool} isBossEnabled this flag is a global bopss Enability flag, which is
 * derived from the UserRegisteredInfo API. Backend sends this flag along with
 * validating country and state bopis availability
 * @param {object} miscInfo object data with pickup eligibility of product
 */

function validateBossEligibility({ isBossClearanceProductEnabled, isBossEnabled, miscInfo }) {
  const bossEligibility = isBossEnabled && miscInfo && miscInfo.isBossEligible;
  // adding this check as productDynamicAbstractor and cartDynamicAbstractor return
  // different keys for clearance item identification
  return miscInfo.isClearance || miscInfo.clearanceItem
    ? isBossClearanceProductEnabled && bossEligibility
    : bossEligibility;
}

/**
 * @method validateBopisEligibility
 * @description checks the bopis product flags for returning the boolean
 * value
 * @param {bool} isBopisClearanceProductEnabled this flag is derived through the kill
 * Switch API. If a product is of Clearance then we need to check this kill switch
 * @param {bool} isBopisEnabled this flag is a global bopis Enability flag, which is
 * derived from the UserRegisteredInfo API. Backend sends this flag along with
 * validating country and state bopis availability
 * @param {object} miscInfo object data with pickup eligibility of product
 */
function validateBopisEligibility({ isBopisClearanceProductEnabled, isBopisEnabled, miscInfo }) {
  const bopisEligibility = isBopisEnabled && miscInfo && miscInfo.isBopisEligible;
  // productDynamicAbstractor and cartDynamicAbstractor return different keys for clearance item
  return miscInfo.isClearance || miscInfo.clearanceItem
    ? isBopisClearanceProductEnabled && bopisEligibility
    : bopisEligibility;
}

/**
 * Determines whether to show the login modal on add items to favorite, based on specified conditions.
 * @param {boolean} isLoggedInUser - Indicates whether the user is logged in.
 * @param {boolean} isGuestFavAppEnabled - Indicates whether the guest favorite app feature is enabled.
 * @param {boolean} showLoginModal - Indicates whether the login modal should be shown.
 * @returns {boolean} - True if the login modal should be shown, false otherwise.
 */
function showLoginModalForFav(isLoggedInUser, isGuestFavAppEnabled, showLoginModal) {
  // If isGuestFavAppEnabled is true, return the value of showLoginModal.
  if (isGuestFavAppEnabled && !isLoggedInUser) {
    return showLoginModal;
  }

  // If isGuestFavAppEnabled is false, return the negation of isLoggedInUser.
  // This ensures that the login modal is shown for logged-out users when the guest feature is disabled.
  return !isLoggedInUser;
}

function guestFavCheck(isGuestFavWebEnabled, isGuestFavAppEnabled) {
  return isGuestFavWebEnabled;
}

export {
  getPromotionalMessage,
  // getAddToBagFormName,
  validateBossEligibility,
  validateBopisEligibility,
  showLoginModalForFav,
  guestFavCheck,
};
